module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg1.svg')"
    }
  }, [_c('div', {
    staticClass: "container g-py-30"
  }, [_c('div', {
    staticClass: "g-max-width-700 text-center mx-auto g-mb-60"
  }, [_c('h2', {
    staticClass: "h1",
    attrs: {
      "id": "errorDiv"
    }
  }, [_vm._v("Resources")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("This page contains resources to help you engage in your community.  If you are looking for help using or navigating this website, check out the "), _c('a', {
    staticClass: "g-font-size-20 g-link-bold",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help page")]), _vm._v(".")])]), _vm._v(" "), _vm._l((_vm.cardItems), function(parentItem, parentIdx) {
    return (_vm.cardItems != null) ? _c('div', {
      staticClass: "card-group d-block d-md-flex g-mx-minus-4"
    }, _vm._l((parentItem), function(item, itemIdx) {
      return _c('div', {
        staticClass: "card g-brd-none g-mx-4 g-mb-8 u-shadow-v38"
      }, [(item.type === 'Card') ? _c('div', [_c('div', {
        staticClass: "card-body g-bg-white rounded g-pa-40"
      }, [(item.iconURL !== null) ? _c('img', {
        staticClass: "resource-page-icon g-mb-20",
        attrs: {
          "src": item.iconURL
        }
      }) : _vm._e(), _vm._v(" "), _c('h3', {
        staticClass: "h3"
      }, [(item.isNew) ? _c('strong', {
        staticStyle: {
          "color": "rgb(166, 29, 55)"
        }
      }, [_vm._v("New! ")]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "g-color-text-light-v1 g-font-size-20--md g-font-size-18"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.description)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "g-view-document g-px-40"
      }, [(!item.isModal && !item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
        attrs: {
          "href": item.linkURL,
          "target": "_blank"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (!item.isModal && item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
        on: {
          "click": function($event) {
            return _vm.RouterRedirect(item.linkURL)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.isModal) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18",
        on: {
          "click": function($event) {
            return _vm.ToggleJotForm(item.jotFormID)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.downloadURL != null) ? _c('a', {
        staticClass: "g-float-right g-color-main g-color-primary--hover",
        attrs: {
          "href": item.downloadURL,
          "target": "_blank",
          "download": "EVF Resource FIle"
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa fa-arrow-circle-down",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (item.type === 'List') ? _c('div', [_c('div', {
        staticClass: "card-body g-bg-white rounded"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-8"
      }, [_c('strong', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "g-color-text-light-v1"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.description)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-4 box"
      }, [_c('div', {
        staticClass: "row center-icon"
      }, [(!item.isModal && !item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover ",
        staticStyle: {
          "padding-left": "50px"
        },
        attrs: {
          "href": item.linkURL,
          "target": "_blank"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (!item.isModal && item.isLocalLInk) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover  ",
        staticStyle: {
          "padding-left": "50px"
        },
        on: {
          "click": function($event) {
            return _vm.RouterRedirect(item.linkURL)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.isModal) ? _c('a', {
        staticClass: "u-link-v5 g-color-main--hover ",
        staticStyle: {
          "padding-left": "50px"
        },
        on: {
          "click": function($event) {
            return _vm.ToggleJotForm(item.jotFormID)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.linkText)
        }
      })]) : _vm._e(), _vm._v(" "), (item.downloadURL != null) ? _c('a', {
        staticClass: "g-float-right g-color-main g-color-primary--hover",
        attrs: {
          "href": item.downloadURL,
          "target": "_blank",
          "download": "EVF Resource FIle"
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa fa-arrow-circle-down",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()])])])])]) : _vm._e()])
    }), 0) : _vm._e()
  }), _vm._v(" "), (_vm.showJotForm) ? _c('jotform-modal', {
    attrs: {
      "Account": _vm.Account,
      "formID": _vm.jotFormID
    },
    on: {
      "closeJotForm": _vm.ToggleJotForm
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c1fd12fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1fd12fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/resourceData/ResourceServices.vue
// module id = 546
// module chunks = 3